import React from 'react';
import { FaOptionIcon } from '@europrocurement/l2d-icons';
import { useTheme } from '@mui/material';
import { type DossierFichier } from '../../../hooks';

type DocumentTypeAlertProps = {
    file: DossierFichier;
    status: string;
};

/**
 * Display a warning tag icon if defined doc type is different as the IADoc
 */
const DocumentTypeAlert: React.FunctionComponent<DocumentTypeAlertProps> = function ({
    file,
    status,
}) {
    const { palette } = useTheme();

    // Check if IADoc document type is different than defined doc type (if status is pending)
    if (status === 'pending' && file.typedocIADoc && file.typeDocDossier) {
        if (file.typedocIADoc.id !== file.typeDocDossier.document?.id) {
            return (
                <FaOptionIcon
                    sx={{
                        position: 'absolute',
                        top: '5px',
                        left: '5px',
                        color: palette.warning.main,
                        fontSize: '12px',
                    }}
                    icon={['fasl', 'tag']}
                />
            );
        }
    }
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return <></>;
};

export default DocumentTypeAlert;
